import React from "react";
import styles from "./Heading.module.css"
const Heading = ({ text, color, borderBottom }) => {
    return <h2 className={styles.h2} style={{
        color: color || "#0f172a",
        borderBottom: borderBottom ? "3px solid black" : "",
        width: borderBottom ? "fit-content" : "",
        padding: borderBottom ? "5px" : "",
        borderRadius: borderBottom ? "2px" : "",

    }}>{text}</h2>;
};

export default Heading;
